export default {
  add_products: '+ Add products',
};
